import { CSRF_TOKEN } from '@/utils/browserStorageNames';

let accessToken: string | null = null;

export const tokenStore = {
  getAccessToken: (): string | null => accessToken,
  setAccessToken: (token: string | null): void => {
    accessToken = token;
  },
  getCsrfToken: (): string | null => localStorage.getItem(CSRF_TOKEN),
  setCsrfToken: (token: string): void => {
    localStorage.setItem(CSRF_TOKEN, token);
  },
  clear: (): void => {
    accessToken = null;
    localStorage.removeItem(CSRF_TOKEN);
  }
};
